export const buildPendingPaidSubscriptionData = (planDetails, isMonthly) => ({
    accountType: '',
    trialActive: false,
    trialEndDate: null,
    subscriptionEndDate: null,
    cancelled: false,
    stripeCustomerId: null,
    pendingPlan: {
        accountType: planDetails.accountType,
        productId: planDetails.productId,
        priceId: isMonthly ? planDetails.priceMonthlyId : planDetails.priceAnnuallyId,
        isMonthly,
    },
});

export const resolveCheckoutPlanState = (locationState = {}, pendingPlan = null, searchParams = null) => {
    const pendingPlanAccountType = typeof pendingPlan === 'string' ? pendingPlan : pendingPlan?.accountType;
    const pendingBillingCycle = pendingPlan?.isMonthly === false ? 'annually' : 'monthly';
    const queryPlan = searchParams?.get?.('plan');
    const queryBillingCycle = searchParams?.get?.('billingCycle');

    return {
        plan: locationState?.plan || queryPlan || pendingPlanAccountType || 'Professional',
        billingCycle: locationState?.billingCycle || queryBillingCycle || pendingBillingCycle,
    };
};
